import ArrowClockwise from './ArrowClockwise';

export default ArrowClockwise;
